import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
const Demo = () => {
  const [loading, setLoading] = useState(false);
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    const formData = new FormData(e.currentTarget);
    const templateParams = {
      from_name: formData.get('name'),
      from_email: formData.get('email'),
      from_phone: formData.get('phone'),
      company: formData.get('company'),
      message: 'New demo request'
    };
    try {
      await emailjs.send('service_14dngmr', 'template_hrwp7el', templateParams, 'THUrewK4qXYV2ddPu');
      alert("Demo request received! We'll be in touch soon.");
      (e.target as HTMLFormElement).reset();
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('There was an error submitting your request. Please try again.');
    } finally {
      setLoading(false);
    }
  };
  return <main className="flex-grow bg-gradient-to-b from-white to-gray-50" data-id="element-332">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-20" data-id="element-333">
        <div className="text-center mb-16" data-id="element-334">
          <h2 className="text-sm text-accent font-bold tracking-widest uppercase" data-id="element-335">
            Book a Demo
          </h2>
          <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-customblack sm:text-4xl" data-id="element-336">
            See Steward in Action
          </p>
          <p className="mt-4 max-w-2xl text-xl text-customgray mx-auto" data-id="element-337">
            Schedule a personalized demo to see how Steward can transform your
            AI search visibility.
          </p>
        </div>

        <div className="bg-white p-8 md:p-10 rounded-2xl shadow-xl border border-gray-100" data-id="element-338">
          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-339">
            <div data-id="element-340">
              <label htmlFor="name" className="block text-sm font-medium text-customgray mb-1" data-id="element-341">
                Name
              </label>
              <input type="text" name="name" id="name" className="block w-full rounded-lg border-gray-300 shadow-sm focus:border-accent focus:ring-accent text-base py-3 px-4 transition-colors" required data-id="element-342" />
            </div>
            <div data-id="element-343">
              <label htmlFor="email" className="block text-sm font-medium text-customgray mb-1" data-id="element-344">
                Email
              </label>
              <input type="email" name="email" id="email" className="block w-full rounded-lg border-gray-300 shadow-sm focus:border-accent focus:ring-accent text-base py-3 px-4 transition-colors" required data-id="element-345" />
            </div>
            <div data-id="element-346">
              <label htmlFor="phone" className="block text-sm font-medium text-customgray mb-1" data-id="element-347">
                Phone Number
              </label>
              <input type="tel" name="phone" id="phone" className="block w-full rounded-lg border-gray-300 shadow-sm focus:border-accent focus:ring-accent text-base py-3 px-4 transition-colors" required pattern="[0-9]{3}[0-9]{3}[0-9]{4}" placeholder="1234567890" data-id="element-348" />
            </div>
            <div data-id="element-349">
              <label htmlFor="company" className="block text-sm font-medium text-customgray mb-1" data-id="element-350">
                Company
              </label>
              <input type="text" name="company" id="company" className="block w-full rounded-lg border-gray-300 shadow-sm focus:border-accent focus:ring-accent text-base py-3 px-4 transition-colors" required data-id="element-351" />
            </div>
            <button type="submit" disabled={loading} className={`w-full bg-accent hover:bg-cyan-400 text-white font-medium py-4 px-4 rounded-lg shadow-md transition duration-150 ease-in-out text-lg mt-4 ${loading ? 'opacity-50 cursor-not-allowed' : ''}`} data-id="element-352">
              {loading ? 'Sending...' : 'Book Demo'}
            </button>
          </form>
        </div>
      </div>
    </main>;
};
export default Demo;